import { observer } from 'mobx-react';
import React from 'react';
import { ORDER_STATUS } from 'src/constants/order';
import { IMessageModal, RefundReasonMessage } from 'src/view/containers/Messages';
import { OrderStore } from '~/mobx/orderStore';

interface IProps {
  data?: IMessageModal;
  orderStore?: OrderStore;
}

// @ts-ignore
// @withOrderStore
@observer
export default class CancelRefund extends React.Component<IProps, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  onRefundSubmit = (refundMessage: string) => {
    if (this.orderStore.order) {
      this.orderStore.changeStatus(this.orderStore.order.id, ORDER_STATUS.CANCELED, refundMessage);
    }
  };

  render() {
    return <RefundReasonMessage price={this.orderStore.order?.total || 0} data={this.props.data} onSubmit={this.onRefundSubmit} />;
  }
}
